import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import contactHero from "../assets/contact-hero.jpg";

const Contact = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <section className="relative w-full h-screen min-h-[600px] flex items-center justify-center overflow-hidden">
        <img
          src={contactHero}
          alt="Kontakta Oss"
          className="absolute inset-0 w-full h-full object-cover"
          width={1920}
          height={1080}
        />
        <div className="hero-overlay absolute inset-0" />
        <div className="relative z-10 text-center px-8 fade-in-up max-w-3xl mx-auto">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl tracking-wide text-foreground uppercase mb-10 leading-[1.15]">
            Kontakta Oss
          </h1>
          <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4">
            <a
              href="tel:+46317303062"
              className="px-6 md:px-8 py-2.5 md:py-3 rounded-full border border-foreground/40 text-xs md:text-sm font-body font-medium uppercase tracking-widest text-foreground hover:bg-foreground hover:text-background transition-all duration-300"
            >
              Tel:031-7303062
            </a>
            <a
              href="mailto:skanstorget@barleys.se"
              className="px-6 md:px-8 py-2.5 md:py-3 rounded-full border border-foreground/40 text-xs md:text-sm font-body font-medium uppercase tracking-widest text-foreground hover:bg-foreground hover:text-background transition-all duration-300"
            >
              Skriv Till Oss
            </a>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Contact;
